import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import TextField from 'libs/formik_fields/TextField';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import FormikFormWrapper from 'libs/formik_fields/FormikFormWrapper';
import SelectField from '../../libs/formik_fields/SelectField';
import { LoadingButton } from '@mui/lab';
import { getStudentRequest } from 'services/requestedTestimonial';
import { useSelector } from 'react-redux';
import { selectUserYearBookTestimonialLimit } from 'store/slices/authSlice';

const emptyTestimonial = {
    student: null,
    comment: ''
};

const testimonialSchema = yup.object().shape({
    student: yup.mixed().required('Please select student of testimonial.'),
    comment: yup.string().required('Please enter comment of testimonial.')
});

const useStyles = makeStyles((theme) => ({
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    }
}));

const TestimonialFormContent = (formik) => {
    const [students, setStudents] = useState([]);
    const userYearBookTestimonialLimit = useSelector(selectUserYearBookTestimonialLimit);
    const { values, setFieldValue, isSubmitting } = formik;

    const navigate = useNavigate();

    const handleBack = useCallback(() => {
        navigate('/');
    }, [navigate]);

    useEffect(() => {
        async function fetchData() {
            //  setLoading(true);
            const data = await getStudentRequest();
            // setLoading(false);
            if (data.error === false) {
                setStudents(data);
                //   setDashboardData(data);
            }
        }
        fetchData();
    }, []);

    const classes = useStyles();

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
                <SelectField name="student" options={students.students} labelKey="name" valueKey="_id" placeholder="Student*" />
            </Grid>
            <Grid item xs={12} md={12}>
                <TextField
                    p="0"
                    name="comment"
                    label="comment*"
                    rows={4.1}
                    multiline
                    inputProps={{ maxLength: userYearBookTestimonialLimit }}
                />

                <Typography>{`${userYearBookTestimonialLimit - values.comment.length} character(s) remaining`}</Typography>
            </Grid>

            <Grid item xs={12} style={{ paddingTop: 0 }}>
                <LoadingButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    disableElevation
                    loading={isSubmitting}
                    loadingPosition="center"
                >
                    Save
                </LoadingButton>
                {/* <Button
                    variant="outlined"
                    color="secondary"
                    sx={{
                        ml: 1
                    }}
                    onClick={handleBack}
                >
                    Cancel
                </Button> */}
            </Grid>
        </Grid>
    );
};

function TestimonialForm({ handleSubmit, initialValues }) {
    return (
        <FormikFormWrapper
            initialValues={initialValues ?? emptyTestimonial}
            onSubmit={handleSubmit}
            validationSchema={testimonialSchema}
            FormContent={TestimonialFormContent}
        />
    );
}

export default TestimonialForm;
